import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Card, CardBody, CardGroup, Col, Container, Form, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import axios from 'axios'
import { api_url } from '../../../config/config'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import { loginUser } from '../../../actions/authActions'

class Login extends Component {

  componentDidMount() {
    if (this.props.auth.isAuthenticated) {
      this.props.history.push('/')
    }
  }
  componentWillReceiveProps(nextProps) {
    if(nextProps.auth.isAuthenticated) {
        this.props.history.push('/')
    }

    if(nextProps.errors){
        this.setState({ errors: nextProps.errors })
    }
  }
  constructor(props) {
    super(props)
    this.state={
      email : '',
      password : '',
      errors: {}
    }

    this.login = this.login.bind(this)
    this.changeInput = this.changeInput.bind(this)
  }
  changeInput(e) {
    var name = e.target.name
    var value = e.target.value
    this.setState({
      [name] : value
    })
  }
  login() {
    const userData = {
      email: this.state.email,
      password: this.state.password
    }

    this.props.loginUser(userData)
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    
                      <h1>Connexion</h1>
                      <p className="text-muted">Connectez vous à votre compte</p>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-user"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input 
                        onChange={this.changeInput}
                        value={this.state.email}                         
                        name="email"
                        type="text" placeholder="Email" autoComplete="username" />
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input 
                        onChange={this.changeInput}
                        value={this.state.password} 
                        name="password"
                        type="password" placeholder="Mot de passe" autoComplete="current-password" />
                      </InputGroup>
                      <Row>
                        <Col className="text-center">
                          <Button onClick={this.login}  color="primary" className="px-4">Se connecter</Button>
                        </Col>
                      </Row>
                  </CardBody>
                </Card>
                
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}


Login.propTypes = {
  loginUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
})

export default connect(mapStateToProps, { loginUser })(withRouter(Login));





// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js